/**
 * Created by olga on 23.05.2025
 */

Map2dDecorators.CLIMBABLE_TRIGGERS[0] = {
    boxes: { code: "chloepetit", stage: 1 },
    hall_wooden_hole1: { code: "mainhallfloor", stage: 1 },
    hall_wooden_hole2: { code: "mainhallfloor", stage: 1 },
    hall_wooden_hole3: { code: "mainhallfloor", stage: 1 },
    hall_torn_wallpaper: { code: "sidehallwall", stage: 1 },
    hall_torn_wallpaper2: { code: "sidehallwall", stage: 1 },
    hall_torn_wallpaper3: { code: "fronthallwall", stage: 1 },
    hall_flower_bed: { code: "extratables", stage: 1 },
    hall_flower: { code: "relaxationzone", stage: 2 },
    hall_sculpture2: { code: "relaxationzone", stage: 2 },
    hall_sculpture: { code: "highart", stage: 1 },
    hall_flower2: { code: "beveragealley", stage: 3 },
    hall_vase: { code: "beveragealley", stage: 3 },
    hall_umbrella_stand: { code: "cozycarpet", stage: 1 },
    hall_hostess_table: { code: "cozybooth", stage: 4 },
    hall_painting: { code: "sidehallwall", stage: 1 },
    hall_doorbathroom: { code: "sidehallwall", stage: 1 },
    hall_doorstorage: { code: "fronthallwall", stage: 1 },

    kitchen_wooden_hole: { code: "kitchenfloor", stage: 1 },
    kitchen_wooden_hole2: { code: "kitchenfloor", stage: 1 },
    kitchen_wooden_hole3: { code: "kitchenfloor", stage: 1 },

    kitchen_dust: { code: "kitchenfloor", stage: 1 },
    kitchen_dust2: { code: "kitchenfloor", stage: 1 },
    kitchen_glass: { code: "kitchenfloor", stage: 1 },
    kitchen_boxes: { code: "yummyisland", stage: 1 },
    kitchen_jars: { code: "cookinguniversity", stage: 1 },
    kitchen_crockery_cart: { code: "gourmetstation", stage: 1 },
    kitchen_painting: { code: "rightkitchenwall", stage: 1 },

    storage_ceramic_hole: { code: "storagefloor", stage: 1 },
    storage_ceramic_hole2: { code: "storagefloor", stage: 1 },
    storage_pail: { code: "storagefloor", stage: 1 },
    storage_box_boards: { code: "storagefloor", stage: 1 },
    storage_jars: { code: "colorfulvitamins", stage: 1 },
    storage_broom: { code: "storagegarbage", stage: 1 },
    storage_ladder: { code: "coldzone", stage: 2 },
    storage_dooroffice: { code: "leftstoragewall", stage: 1 },

    office_dust: { code: "officefloor", stage: 1 },
    office_wooden_hole1: { code: "officefloor", stage: 1 },
    office_dresser_plasterheads: { code: "naturesrighteye", stage: 2 },
    office_globe: { code: "frontdesk", stage: 2 },

    bathroom_ceramic_hole: { code: "bathroomfloor", stage: 1 },
    bathroom_ceramic_hole2: { code: "bathroomfloor", stage: 1 },
    bathroom_ceramic_hole3: { code: "bathroomfloor", stage: 1 },
    bathroom_ceramic_wall_hole1: { code: "leftbathroomwall", stage: 1 },
    bathroom_ceramic_wall_hole2: { code: "rightbathroomwall", stage: 1 },
    bathroom_ceramic_wall_hole3: { code: "rightbathroomwall", stage: 1 },
    bathroom_flower3: { code: "wonderfulview", stage: 1 },

    bathroom_ottoman: { code: "indoorsecology", stage: 1 },
    bathroom_toiletpaper: { code: "indoorsecology", stage: 1 },

    staffroom_ceramic_hole: { code: "staffroomfloor", stage: 1 },
    staffroom_ceramic_hole2: { code: "staffroomfloor", stage: 1 },
    staffroom_flower: { code: "staffroomfloor", stage: 1 },

    staffroom_mirror: { code: "rightbathroomwall", stage: 1 },
    staffroom_wallclock: { code: "rightbathroomwall", stage: 1 },
    staffroom_puddle: { code: "cleanstorm", stage: 1 },
    staffroom_puddle2: { code: "cleanstorm", stage: 1 },
    staffroom_broom: { code: "fashiondeposit", stage: 1 }
};

if (cleverapps.config.debugMode) {
    Map2dDecorators.findDuplicateAndMissingClimbables = function () {
        const seen = {};
        const duplicates = [];
        Map2d.currentMap.decorators.iterateDecorators((decorator) => {
            if (!decorator.isClimbable()) {
                return;
            }
            if (seen[decorator.code]) {
                duplicates.push(seen[decorator.code], decorator);
            } else {
                seen[decorator.code] = decorator;
            }
        });
        const locationId = cleverapps.meta.selectedLocationId();

        return {
            missing: cleverapps.substract(Object.keys(Map2dDecorators.CLIMBABLE_TRIGGERS[locationId]), Object.keys(seen)),
            duplicates
        };
    };
}